module.exports = __webpack_public_path__ + "img/clarity@2x.e8ce83a.jpg";